const banner = document.querySelector('[data-behaviour="notification-banner"]');

if ( banner ) {

    const closeButton = banner.querySelector('[data-action="close"]');

    if(closeButton) {
        closeButton.addEventListener('click', (ev) => {
            ev.preventDefault();
            banner.parentNode.removeChild(banner);
        });
    }

}